<template>
  <div>		
		<div class="pg-header">
			<div>
				<label class="title">患者分组</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<!-- <router-link to="/">患者管理</router-link>| -->
					<span>患者管理</span>|
					<span class="active">患者分组</span>
				</div>
				<a class="back noline" @click="goBack">返回</a>
			</div>
		</div>
		
		<div class="table-wrap">
			<div class="search-bar">
				<label>分组名称
					<el-input size="small" placeholder="分组名称" clearable v-model="filter.groupingName" @keyup.enter.native="handleFilter(0)"></el-input>
				</label>
				<el-button size="mini" icon="el-icon-search" round @click="handleFilter(0)">搜索</el-button>
			</div>
			<div class="action-bar">
				<el-button type="primary" size="mini" round @click="showDlg">新增分组</el-button>
				<template v-if="multipleSelection.length === 0">
					<el-button slot="reference" size="mini" round plain disabled>批量删除</el-button>
				</template>
				<el-popconfirm v-else confirmButtonText='删除' title="确定批量删除吗？" @confirm="delItem">
					<el-button slot="reference" type="danger" size="mini" style="margin-left: 10px;" round plain>批量删除</el-button>
				</el-popconfirm>

				
			</div>
			<el-table ref="multipleTable"  header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<el-table-column fixed="left" type="selection" width="55"></el-table-column>
				<el-table-column prop="groupingName" label="组名"></el-table-column>
				<el-table-column prop="tags" label="疾病标签" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="description" label="分组描述" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="patientNum" label="患者人数" width="100"></el-table-column>
				<el-table-column prop="creator" label="创建人" width="100"></el-table-column>
				<el-table-column prop="sort" label="排序" width="100"></el-table-column>
				<!-- <el-table-column prop="date" label="更新时间" width="200"></el-table-column> -->
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<el-tooltip content="查看" placement="top" :enterable="false"><router-link :to="{name: 'Patient/GroupView', query: {groupingId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline" @click="showDlg(scope.row)"></i></el-tooltip>
							<el-popconfirm confirmButtonText='确定' title="确定同步患者吗？" @confirm="syncItem(scope.row)">
							<el-tooltip content="同步" slot="reference" placement="top" :enterable="false"><i class="icon-sync"></i></el-tooltip>
							</el-popconfirm>
							<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>
						</div>
					</template>
				</el-table-column>
			</el-table>	
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog :title="form.id > 0? '修改分组' : '新增分组'" width="760px" center :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="分组名称" prop="groupingName">
					<el-input autocomplete="off" maxlength="10" :show-word-limit="true" v-model="form.groupingName"></el-input>
				</el-form-item>
				<el-form-item label="分组描述" prop="description">
					<el-input type="textarea" autocomplete="off" rows="5" maxlength="100" resize="none" :show-word-limit="true" v-model="form.description"></el-input>
				</el-form-item>
				<el-form-item label="排序" prop="sort">
					<div>
						<el-input-number label="排序" :min="1" :max="99" v-model="form.sort"></el-input-number>
					</div>
					
				</el-form-item>	
				<el-form-item label="自动分组" prop="auto">
					<el-switch v-model="form.auto" active-text="启用"></el-switch>
				</el-form-item>
				<el-form-item v-if="form.auto" label="疾病标签" prop="dictIds">
					<el-transfer :titles="['全部疾病标签', '已选疾病标签']" :props="{key: 'tagId', label: 'tagName' }" :data="diseaseTagList" v-model="diseaseTag"></el-transfer>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
		
  </div>
	
			
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
	mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					groupingName: {required: true, message: '请输入分组名', trigger: 'blur'}
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				groupingName: '',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				groupingName: '',
				description: '',
				auto: false,
				dictIds: undefined,
				sort:1
			},
			diseaseTag: [],
			diseaseTagList: undefined
		}
	},
	created() {
		this.loadList();

		// 加载疾病标签
		this.loadPatientAllTag();
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getPatientGroupList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
					item.tags = item.tags?.map(item => item.dictName).join('、');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		// 疾病标签
		async loadPatientAllTag() {
			let res = await api.getPatientAllTag();
			if (res.code === 1000) {
				if (res.data.diseaseTagList) {
					this.diseaseTagList = res.data.diseaseTagList;
				}
			}
		},
		showDlg(item) {
			this.dlg.active = true;
			if (item && item.id > 0) {
				this.$nextTick(async ()=>{
					this.$refs['form'].resetFields();
					let res = await api.getPatientGroupById(item.id);
					this.form = { auto: false, ...res.data};
					this.diseaseTag = this.form.tags.map(item=> item.dictId);
					if (this.diseaseTag.length > 0) {
						this.form.auto = true;
					} else {
						this.form.auto = false;
					}
					// this.form.id = item.id;
					// this.form.groupingName = item.groupingName;
					// this.form.description = item.description;
					// console.log('数据啊', this.form.tags.map(item=> item.dictId));
					// this.$refs['tree'].setCheckedKeys(this.form.tags.map(item=> item.dictId));
				});
			} else {
				this.form.id = 0;
				this.$nextTick(()=>{
					this.diseaseTag = [];
					this.$refs['form'].resetFields();
				});
			}
		},
		closeDlg() {
			this.dlg.active = false;
		},
		async saveForm() {
			let res;
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					// this.form.dictIds = JSON.stringify(this.diseaseTag);
					this.isLoading = true;
					this.form.dictIds = this.diseaseTag;
					if (!this.form.auto) {
						this.form.dictIds = undefined;
					}
					if (this.form.id > 0) {
						res = await api.editPatientGroup(this.form);
						this.syncItem(this.form);
					} else {
						// 后端问题，不能带这参数
						this.form.id = null;
						res = await api.addPatientGroup(this.form);
						this.syncItem(res.data);

					}
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({message: '保存成功',type: 'success'});
					this.isLoading = false;
					this.closeDlg();
				}
			})
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return;}
			
			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delPatientGroup({groupingIds: item.id});
			} else {
				// 批量删除
				if (this.multipleSelection.length == 0) {
					this.isLoading = false;
					return this.$message.warning('未选择任何数据');
				}
				res = await api.delPatientGroup({groupingIds: this.multipleSelection.join(',')});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		async syncItem(item) {
			let res;
			// if (this.isLoading) { return;}
			
			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.syncPatientGroup({id: item.id});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '同步成功',type: 'success'});
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter() {
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
</style>
